import { render, staticRenderFns } from "./valuationReport.vue?vue&type=template&id=735223b4&scoped=true&"
import script from "./valuationReport.vue?vue&type=script&lang=js&"
export * from "./valuationReport.vue?vue&type=script&lang=js&"
import style0 from "./valuationReport.vue?vue&type=style&index=0&id=735223b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735223b4",
  null
  
)

export default component.exports